import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const {
  requestCard,
  fetchCustomCards,
  fetchCardDesign,
  getCardInfo,
  submitCardRecharge,
  approveCardRecharge,
  declineCardRecharge,
  getPendingRecharges,
} = endpoints;

const requestNewCard = async (data: any) => {
  try {
    const response = await axios.post(requestCard, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getCustomCards = async (params: any) => {
  try {
    const response = await axios.get(fetchCustomCards, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getCardDesign = async (id: string) => {
  try {
    const response = await axios.get(fetchCardDesign(id), { responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    return URL.createObjectURL(fileBlob);
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const fetchCardInfo = async (cardNumber: string) => {
  try {
    const response = await axios.post(getCardInfo, { cardNumber });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const submitCardRechargeRequest = async (data: any, idempotencyKey: string) => {
  try {
    const response = await axios.post(submitCardRecharge, data, { headers: { 'X-Idempotency-Key': idempotencyKey } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const approveCardRechargeFunc = async (data: any) => {
  try {
    const response = await axios.post(approveCardRecharge, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const declineCardRechargeFunc = async (data: any) => {
  try {
    const response = await axios.post(declineCardRecharge, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getPendingRechargesFunc = async (params: any) => {
  try {
    const response = await axios.get(getPendingRecharges, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const cardsServices = {
  requestNewCard,
  getCustomCards,
  getCardDesign,
  fetchCardInfo,
  submitCardRechargeRequest,
  approveCardRecharge: approveCardRechargeFunc,
  declineCardRecharge: declineCardRechargeFunc,
  getPendingRecharges: getPendingRechargesFunc,
};

export default cardsServices;
